import { API_ENDPOINTS } from '../config/api'
import { getActiveOrgId } from '../utils/orgUtils'

function withOrganizationScope(url: string): string {
  const orgId = getActiveOrgId()
  if (!orgId) return url
  const sep = url.includes('?') ? '&' : '?'
  return `${url}${sep}organization_id=${encodeURIComponent(orgId)}`
}

function getAuthHeaders(): HeadersInit {
  const token =
    typeof window !== 'undefined'
      ? localStorage.getItem('token') || localStorage.getItem('accessToken')
      : null
  return token ? { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json' }
}

async function parseJson(res: Response) {
  const body = await res.json()
  if (!res.ok) throw new Error(body?.message || body?.error || 'Request failed')
  return body?.data ?? body
}

export type OperationalEvent = {
  id: string
  eventType: string
  eventSource: string
  severity: string
  relatedStandardCode?: string | null
  explanations?: { summary?: string }
  createdAt: string
}

export async function fetchRuntimeEvents(standardCode?: string) {
  const q = standardCode ? `?standardCode=${encodeURIComponent(standardCode)}` : ''
  const res = await fetch(withOrganizationScope(`${API_ENDPOINTS.COMPLIANCE_RUNTIME_EVENTS}${q}`), {
    headers: getAuthHeaders(),
  })
  return parseJson(res) as { events: OperationalEvent[]; graphOverlay?: unknown }
}

export async function fetchRuntimeTimeline(standardCode?: string) {
  const q = standardCode ? `?standardCode=${encodeURIComponent(standardCode)}` : ''
  const res = await fetch(withOrganizationScope(`${API_ENDPOINTS.COMPLIANCE_RUNTIME_TIMELINE}${q}`), {
    headers: getAuthHeaders(),
  })
  return parseJson(res) as { timeline: Array<{ id: string; at: string; eventType: string; severity: string; summary: string }> }
}

export async function fetchRuntimeDegraded(standardCode?: string) {
  const q = standardCode ? `?standardCode=${encodeURIComponent(standardCode)}` : ''
  const res = await fetch(withOrganizationScope(`${API_ENDPOINTS.COMPLIANCE_RUNTIME_DEGRADED}${q}`), {
    headers: getAuthHeaders(),
  })
  return parseJson(res) as { degraded: OperationalEvent[]; count: number }
}

export async function fetchRuntimeRecovering(standardCode?: string) {
  const q = standardCode ? `?standardCode=${encodeURIComponent(standardCode)}` : ''
  const res = await fetch(withOrganizationScope(`${API_ENDPOINTS.COMPLIANCE_RUNTIME_RECOVERING}${q}`), {
    headers: getAuthHeaders(),
  })
  return parseJson(res) as { recovering: OperationalEvent[]; count: number }
}

export async function recomputeComplianceRuntime() {
  const res = await fetch(withOrganizationScope(API_ENDPOINTS.COMPLIANCE_RUNTIME_RECOMPUTE), {
    method: 'POST',
    headers: getAuthHeaders(),
  })
  return parseJson(res)
}
